var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ButtonContainer } from './styles/button.styled';
const Button = (_a) => {
    var { className, children, color, variant = 'on-light', dataTest = `button-${color}`, size = 'normal', type = 'button', href } = _a, props = __rest(_a, ["className", "children", "color", "variant", "dataTest", "size", "type", "href"]);
    return (React.createElement(ButtonContainer, Object.assign({ "$variant": variant, "$color": color, "$size": size, className: className, "data-test": dataTest, tagName: href !== undefined ? 'a' : 'button' }, (href === undefined ? { type } : { href }), props), children));
};
export default Button;
//# sourceMappingURL=Button.js.map